var removeQuotesChar = function removeQuotesChar(placeholder) {
  return placeholder.slice(1, -1);
};
export default removeQuotesChar;